import React from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Option({
  icon,
  label,
  children,
  to,
}) {
  return (
    <Col xl="3" lg="4" md="6" className="mb-3">
      <Link to={to} className="btn bg-white btn-block p-5 border h-100 text-left shadow-hover" style={{ width: '100%' }}>
        <p>
          <FontAwesomeIcon fixedWidth icon={icon} size="2x" className="text-primary me-3" />
          <span className="h5 text-dark my-4 font-weight-bold">{label}</span>
        </p>
        <p className="text-body font-large mb-0">{children}</p>
      </Link>
    </Col>
  );
}

export default Option;
